//MIGRATION: This is a straight copy of the bpm-frontend main.jsx with two modifications.
//    1. Removal of the styleLoader.js (since it just imports tinuiti.scss and was causing errors)
//    2. Addition of the StrictMode wrapper from react
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";

import React from "react";

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import "./utils/mixpanelWrapper";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import "react-filter-box-updated/lib/react-filter-box.css";

//MIGRATION: We used to use styleLoader.js to handle loading the appropriate agency CSS. But now we only have one, so just import the tinuiti.scss directly
// This needs to come before the App import so all our sass throughout the app has precedence over
// the bootstrap styles.
// import "./styleLoader.js";
import "./tinuiti.scss";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import { reduxStore, createReduxStore } from "./redux";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_STAGE,
  integrations: [new Integrations.ExtraErrorData(), new Integrations.Dedupe()],
});

Sentry.setTag("amplify_build", import.meta.env.VITE_AWS_JOB_ID || "n/a");

// This is all related to CORS issues from running bpm-web in iframe. We can potentially get rid of
// this once we stop doing that.
if (!document.domain.endsWith("amplifyapp.com")) {
  try {
    document.domain = import.meta.env.VITE_DOMAIN;
  } catch (e) {
    // Setting document.domain seems to fail when loading our app in an iFrame, which I don't care
    // about.
    console.log(e.message);
  }
}

createReduxStore();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Cache kept for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnMount: false, // Don't refetch on component mount if data exists
      retry: 1, // Only retry failed requests once
    },
  },
});

//MIGRATION: Adjusted this so that it matches the new create-react-app. Also note that we have the `StrictMode` wrapper
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={reduxStore}>
      <QueryClientProvider client={queryClient}>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </QueryClientProvider>
    </Provider>
  </StrictMode>
);
